import style from './footer.module.css';

import github from '../../assets/icons/github.svg';
import linkedin from '../../assets/icons/linkedin.svg';

export default function Footer() {
  return (
    <footer className={style.footer}>
      <p>&copy; {new Date().getFullYear()}</p>
      <div>
        <a
          href="https://www.linkedin.com/in/alexgchun"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="" />
        </a>
        <a href="https://github.com/alexgchun" target="_blank" rel="noreferrer">
          <img src={github} alt="" />
        </a>
      </div>
    </footer>
  );
}
